export default "__VITE_ASSET__33d553ba__"